import { FC } from 'react';
import { useFormContext } from 'react-hook-form';
import Text from '@components/common/text';
import Button from '@components/common/button';
import TextareaField from '@components/common/hookFormFields/textareaField';
import PassReviewQuestionListRs, { PassReviewQuestionDto } from '@domain/rs/passReview/PassReviewQuestionListRs';
import { FontStyle } from '@domain/constant/fontStyle';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface ItemProps extends HookFormProps {
  data: PassReviewQuestionDto;
}
const Item: FC<ItemProps> = ({ data, prefixName }) => {
  const rules = {
    validate: (value?: string) => {
      if (data.minLength && (value?.length ?? 0) < data.minLength) {
        return '최소 글자수 이상 입력해 주세요.';
      }
      if (!value) return '내용을 입력해 주세요.';
    },
  };

  const {
    watch,
    formState: { isSubmitted },
  } = useFormContext();

  const textLength = watch(`${prefixName}`)?.length ?? 0;
  const isError = isSubmitted && textLength < data.minLength;

  return (
    <div className={cx('formItem')}>
      <Text fontStyle={FontStyle.B2P_B} styles={{ display: 'flex', alignItems: 'center' }}>
        {data.question}
        {data.minLength && <span className={cx('minLength', { error: isError })}>(최소 {data.minLength}자)</span>}
      </Text>
      <TextareaField
        prefixName={prefixName}
        height={94}
        placeholder={'내용을 입력해 주세요.'}
        rules={rules}
        maxLength={data.maxLength}
        autoHeight
      />
    </div>
  );
};

interface Props {
  data?: PassReviewQuestionListRs;
}
const PassInfo = ({ data }: Props) => {
  const questionEls = data?.questions.map((item, idx) => (
    <Item key={item.questionSn} data={item} prefixName={`answers.${idx}`} />
  ));

  return (
    <div className={cx('form')}>
      {questionEls}

      <div className={cx('btnArea')}>
        <Button className={cx('btn')} theme="primary" type="submit">
          등록
        </Button>
      </div>
    </div>
  );
};

export default PassInfo;
